import React, {useEffect} from 'react';
import animationData from './loader.json'

const Loader = ({ show_loader, style }) => {
	try {

		const default_style = {
			width: '100%', 
			height: '100%', 
			overflow: 'hidden',
			display: show_loader ? 'block' : 'none'/*,
			backgroundColor: 'rgba(0.8,0.8,0.8,0.3)',
			position: 'absolute'*/
		}

		const update_loader = () => {	       	
            var loader = window.document.getElementsByClassName("bodymovin");
            function loadBMAnimation(loader) {
                var animation = window.bodymovin.loadAnimation({
                    container: loader,
                    renderer: "svg",
                    loop: true,
                    autoplay: true,
                    animationData,
                    name: 'loader_animation'
                });
            }

            for (var i = 0; i < loader.length; i++) {
                loadBMAnimation(loader[i]);
            }
	    }

	    useEffect(() => {
	    	if (show_loader) {
	    		update_loader()
	    	}else{
	    		window.bodymovin.destroy('loader_animation')
	    	}
	    }, [ show_loader ])

	    return (
            // <div style={{ ...default_style, ...style }} > Loading...</div>
            <div style={{ ...default_style, ...style }} className="bodymovin loader_overlay" > </div>
	    );

	} catch(err) {
		return 'Loader has crashed'
	}
}

export default Loader;